const cardUpdateTypes = {
  all: {
    value: 0,
    name: '修改多项',
    icon: 'update-all',
  },
  date: {
    value: 1,
    name: '修改日期',
    icon: 'update-date',
  },
  number: {
    value: 2,
    name: '修改次数',
    icon: 'update-number',
  },
  type: {
    value: 3,
    name: '修改课卡类型',
    icon: 'update-type',
  },
  lock: {
    value: 4,
    name: '锁卡',
    icon: 'lock',
  },
  unlock: {
    value: 5,
    name: '取消锁卡',
    icon: 'unlock',
  },
  stop: {
    value: 6,
    name: '停卡',
    icon: 'stop',
  },
  unstop: {
    value: 7,
    name: '提前开卡',
    icon: 'unstop',
  },
};

export const cardUseControlTypeValues = [
  cardUpdateTypes.lock.value,
  cardUpdateTypes.unlock.value,
  cardUpdateTypes.stop.value,
  cardUpdateTypes.unstop.value,
];

// 学员自助停卡原因类型（card_update_apply.stop_reason_type）
export const cardStopReasonTypes = {
  business: { value: 1, name: '出差' },
  injury: { value: 2, name: '伤病' },
  pregnancy: { value: 3, name: '怀孕' },
  other: { value: 4, name: '其他' },
};

export default cardUpdateTypes;
